import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { WebService } from 'src/app/shared/services/web.service';
import { NgForm } from '@angular/forms';


declare var $: any, bootbox: any;
@Component({
   selector: 'app-forgot-password',
   templateUrl: './forgot-password-component.html',
   styleUrls: ['./forgot-password-component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class ForgotPasswordComponent {

  email: string;
  searchLoginObj = new LoginObject();
  searchLoginObj1 = new LoginObject();								  
  Apiurl = '';
  button: boolean = false;
  @ViewChild('loginForm') loginForm: NgForm;
  @ViewChild('verifyForm') verifyForm: NgForm;
  validation: boolean = false;
  otpvalidation: boolean = false;
  constructor(
    private router: Router, private webService: WebService
  ) { }
  ngOnInit() {
    setTimeout(() => { $('#newsTicker1').breakingNews(); }, 500)
   
  }
  forgetPassword() {
    
    if (!this.loginForm.valid) {
      this.validation = true;
    }
    else {
      this.Apiurl = "api/OtpGenerate/forgetPassword";
this.searchLoginObj1.Loginname = this.webService.encryptData(this.searchLoginObj.Loginname)																								 
      this.webService.postData(this.Apiurl, this.searchLoginObj1).subscribe((data: any) => {
        
        if (data.statusCode == 204) {
          bootbox.alert(data.message);
          return false;
        }
        else if (data.statusCode == 200) {
          this.button = true;
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>OTP Sent Successfully</h6></div>",
            size: 'large'
          });
        }

      })
    } 
  }

  verfiyOtp() {
    if (!this.verifyForm.valid) {
      this.otpvalidation = true;
    }
    else {
      this.Apiurl = "api/OtpGenerate/VerfiyOtp";
      this.webService.postData(this.Apiurl, this.searchLoginObj).subscribe((data: any) => {
        
        if (data.statusCode == 204) {
          bootbox.alert(data.message);
          return false;
        }
        else if (data.statusCode == 200) {
          this.button = true;
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>OTP verify & new password send on your registered Email id. Please check your email.</h6></div>",
            size: 'large'
          });
          this.router.navigate(['login']);
        }

      })
    }
    
  }





  resendotp() {
    this.Apiurl = "api/OtpGenerate/ReSendOtpOnForGetPassword";
    this.webService.postData(this.Apiurl, this.searchLoginObj).subscribe((data: any) => {
      
      if (data.statusCode == 204) {
        bootbox.alert(data.message);
        return false;
      }
      else if (data.statusCode == 200) {
        this.button = true;
        bootbox.alert({
          message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>OTP Resend on your registered Email id. Please check your email.</h6></div>",
          size: 'large'
        });
        
        
      }

    })
  }
  send() {
    this.router.navigate(['/']);
  }

}

export class LoginObject {
  Loginname: string;
  LoginOtp: string;
}


